import React from 'react';
import logo from './logo.svg';
import githublogo from './githublogo.png';
import devpost from './devpost.svg'

import './App.css';
import {ProjectBox} from './components/project-box/project';
import {ProjectBoxRow} from './components/project-box-row/projectBoxRow';
import {Title} from './components/title/title';

class App extends React.Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <Title title="Shreya Jain"></Title>
          <h2 className="sectionTitle neonLightBlueBG">Welcome</h2>
          <hr className="break"></hr>
          <p className="welcomeText navyText">Welcome to my website! My name is Shreya. I am a student at Dartmouth College. I love learning about new technologies and computational applications in engineering and research.</p>
          
          <h2 className="sectionTitle neonLightBlueBG">Projects</h2>
          <ProjectBoxRow numBoxes="2"></ProjectBoxRow>

          <h2 className="sectionTitle neonLightBlueBG">Contact</h2>
          <p className="welcomeText navyFooter">School Email: shreya.jain.25@dartmouth.edu</p>
          <p className="welcomeText navyFooter">Personal Email: shreyyajain@gmail.com</p>
          <p className="welcomeText navyFooter">Other profiles</p>
          <a href="https://devpost.com/shreyaj1212?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav"><img src={devpost} class="image"></img></a>

        </header>
        <body>
        
        </body>
      </div>
    );
  }
}

export default App;
